module.exports = __webpack_public_path__ + "static/img/aa4.cf6d70d0.png";